import React from 'react';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import styled from 'styled-components';

import InternalLink from '../InternalLink';
import { media } from '../styles/breakpoints';
import * as types from './../../actions/actionTypes';

const SubcategoryGalleryPaneCard = ({ title, thumbnail, categoryid, sewpatId }) => {
    const Media = styled(CardMedia)`
        padding: 0px;
        line-height: 1;
        
        & img {
          height: auto;
          width: 100%;
        }
        
        &:last-child {
          padding-bottom: 0px;
        }
    `;

    const CardHeader = styled.div`
          font-weight: normal;
          font-size: 0.81em;
          margin: 0px;
          line-height: 1.31;
          padding: 0.2em;
    `;

    return (
        <Card className='gallery-pane-card' >
            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_CATEGORIE_PATTERNS_GALLERY,
                    payload: {
                        categoryid,
                        sewpatId,
                        slug: 'pattern',
                    },
                }}
            >
                <Media>
                    <img src={thumbnail} />
                </Media>
                <CardHeader>
                    {title}
                </CardHeader>
            </InternalLink>
        </Card>
    );
};

export default SubcategoryGalleryPaneCard;



// WEBPACK FOOTER //
// ./src/components/categories/SubcategoryGalleryPaneCard.js